export default "data:text/javascript;base64,aW1wb3J0IFRNZXNzYWdlVHlwZSBmcm9tICIuL1RNZXNzYWdlVHlwZS52dWUiOwoKZXhwb3J0IGRlZmF1bHQgVE1lc3NhZ2VUeXBlOwo="